const planBook = [{
  desc: '商户端-计划书管理-列表',
  options: {
    url: '/planbookBasic/queryList',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-planbook'
  }
}, {
  desc: '商户端-计划书管理-操作-删除',
  options: {
    url: '/planbookBasic/delete',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-planbook'
  }
}, {
  desc: '商户端-计划书管理-获取跳转链接',
  options: {
    url: '/planBook/retrieveUrl',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-planbook'
  }
}, {
  desc: '查询当前计划书的浏览人数明细',
  options: {
    url: '/planBook/wechat/visitors',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-planbook'
  }
}, {
  desc: '计划书保司',
  options: {
    url: '/planbookCompany/queryCompanys',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-planbook'
  }
}]
export default planBook



// WEBPACK FOOTER //
// ./src/api/planBook.js